import React, { useImperativeHandle, useState } from 'react'
import styled from 'styled-components';
import useAsyncEffect from 'use-async-effect';
import { useDispatch } from 'react-redux';
import 'react-quill/dist/quill.snow.css';
import { loading } from '../../../actions/Loading';
import api from '../../../api/api';
import { GetCampaignsResult } from '../../../model/GetCampaignsResult';
import NewCampaignComponent from '../../campaign/NewCampaignComponent';
import CampaignsTable from '../../campaign/CampaignsTable';


interface IProps {
    stockId: string;
}

const Style = styled.div`
margin: 1rem 0;



`;


export interface ICampaignPageMethods {
    save: () => Promise<boolean>
}


const CampaignPage = React.forwardRef<any, IProps>((props: IProps, ref) => {

    const dispatch = useDispatch();
    const [campaignResult, setCampaignResult] = useState<GetCampaignsResult>();
    const [editingCampaignId, setEditingCampaignId] = useState<string>('');
    const newCampaignComponent = React.createRef<ICampaignPageMethods>();

    
    const refresh = async ()=>{
        dispatch(loading(true));
        const result = await api().getCampaigns(props.stockId);
        setCampaignResult(result);
        dispatch(loading(false));
    }
    
    useAsyncEffect(async (isMounted: () => boolean) => {
        
        await refresh();
        
    }, []);

    


    useImperativeHandle(ref, (): ICampaignPageMethods => ({

        async save() {
            
            if(editingCampaignId){
                return newCampaignComponent.current!.save();
            }
            return true;
        }

    }));

    const onEditorClose = async ()=>{
        setEditingCampaignId('')
        await refresh();
    }


    return <Style>
        {
            !editingCampaignId && <div className="space-between">
            <h2>Campaigns</h2>
            <button onClick={()=>setEditingCampaignId('new')}>Start New Campaign</button>
        </div>
        }
        {
            !!editingCampaignId && <NewCampaignComponent ref={newCampaignComponent} stockId={props.stockId} onClose={onEditorClose} campaignId={editingCampaignId}/>
        }
        
        
        {
            !editingCampaignId && campaignResult && <CampaignsTable campaignResult={campaignResult} onEditCampaign={setEditingCampaignId}/>
            
        }
    </Style>
});

export default CampaignPage;